import React, {Component} from 'react'
import Header from '../components/header.js'
import Footer from '../components/footer.js'
import {Row, Col} from "react-bootstrap"
import '../../static/css/page.css'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import $ from 'jquery'
import timeicon from '../../static/images/time.png'
import localicon from '../../static/images/local.png'
import mglx1 from '../../static/images/mglx1.jpg'
import mglx2 from '../../static/images/mglx2.jpg'
import mglx3 from '../../static/images/mglx3.jpg'
import mglx4 from '../../static/images/mglx4.jpg'
import mglx5 from '../../static/images/mglx5.jpg'
import mglx6 from '../../static/images/mglx6.jpg'
import ylblx1 from '../../static/images/ylblx1.jpg'
import ylblx2 from '../../static/images/ylblx2.jpg'
import ylblx3 from '../../static/images/ylblx3.jpg'
import ylblx4 from '../../static/images/ylblx4.jpg'
import ylblx5 from '../../static/images/ylblx5.jpg'
import ylblx6 from '../../static/images/ylblx6.jpg'
import lcbl1 from '../../static/images/lcbl1.png'
import lcbl2 from '../../static/images/lcbl2.png'
import lcbl3 from '../../static/images/lcbl3.png'
import lcbl4 from '../../static/images/lcbl4.png'
import lcbl5 from '../../static/images/lcbl5.png'
import lcbl6 from '../../static/images/lcbl6.png'
import lcbl7 from '../../static/images/lcbl7.png'
import lcbl8 from '../../static/images/lcbl8.png'
import lcbl9 from '../../static/images/lcbl9.png'
import api from "../../api/api"

import {Link} from "react-router-dom"
import {baiduTongJI} from "../../api/utils"

class Home extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isClicks: true,
			successCase: [
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/case/glby.jpg',
					name: '哥伦比亚大学',
					sname: 'L同学 ',
					xueke: '',
					sta: ' GRE：325',
					tuofu: '托福：96'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/case/casedld.jpg',
					name: ' 多伦多大学',
					sname: 'M同学 ',
					xueke: '',
					sta: 'SAT ： 1410',
					tuofu: '托福 ： 100'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/case/caseglne.jpg',
					name: '格林耐尔学院',
					sname: 'D同学',
					xueke: '',
					sta: 'SAT ： 1410',
					tuofu: '托福 ： 101'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/case/casejqdx.jpg',
					name: '剑桥大学',
					sname: 'Z同学',
					xueke: '',
					sta: '雅思 ：7.0',
					tuofu: ''
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/case/casenjz.jpg',
					name: '南加州大学',
					sname: 'W同学',
					xueke: '',
					sta: 'SAT ： 1460',
					tuofu: '托福 ： 114'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/case/casenydx.jpg',
					name: '纽约大学',
					sname: 'W同学',
					xueke: '',
					sta: 'SAT ： 1450',
					tuofu: '托福 ： 103'
				},

			],
			teacherList: [
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/1.png',
					name: '夏老师',
					lable: '首席升学专家'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/2.jpg',
					name: '陈老师',
					lable: '首席升学专家'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/3.png',
					name: '陶老师',
					lable: '美英留学主顾问'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/4.jpg',
					name: '谢老师',
					lable: '高级留学规划师'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/5.png',
					name: '宋老师',
					lable: '高级留学规划师'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/6.jpg',
					name: '任老师',
					lable: '高级留学规划师'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/7.jpg',
					name: '俞老师',
					lable: '英联邦留学主顾问'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/8.jpg',
					name: '万老师',
					lable: '美英留学主顾问'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/9.png',
					name: '孙老师',
					lable: '美籍顾问'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/10.jpg',
					name: '范老师',
					lable: '美英留学主顾问'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/11.png',
					name: 'Dominic',
					lable: '美籍顾问'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/12.jpg',
					name: '金老师',
					lable: '美英留学主顾问'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/13.png',
					name: 'Jeremy',
					lable: '美籍顾问'
				},
				{
					img: 'http://ambcdn.eduugo.com/amedu/img/teacher/14.jpg',
					name: '蔡老师',
					lable: '美英留学主顾问'
				},

			],
			bans:[],
			homeData:{},
			country:[],
			countryActive:{},
			news:[]
		}
	}
	getCountry=async ()=>{
		let res=await api.post('/home/get-country',{})
		this.setState({country:res.data,countryActive:res.data[0]},()=>{
			this.getNews()
		})
	}
	getNews=async ()=>{
		let res=await api.post('/home/get-news',{country: this.state.countryActive.id})
		this.setState({news:res.data})

	}
	countryChange=async (item)=>{
		this.setState({countryActive:item},async ()=>{
			this.getNews()
		})
	}
	clickIt = () => {
		this.setState({
			isClicks: !this.state.isClicks
		})
	}
	selectElement = () => {
		$('#nb_invite_ok').click()
	}

	componentDidMount() {
		this.getBans()
		this.getHomeData()
		this.getCountry()
		// baiduTongJI()
	}
	getHomeData=async ()=>{
		let res=await api.get('/home')
		this.setState({
			homeData:res.data,
			teacherList:res.data.adviser.data,
			successCase:res.data.case.data
		})
	}
	getBans = async () => {
		let res = await api.get('/banners/get-list')
		this.setState({bans:res.data.list})
	}

	render() {
		const bannerSet = {
			dots: false,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
		}
		const sets = {
			autoplay: true,
			dots: false,
			infinite: true,
			speed: 500,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						dots: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						initialSlide: 1,
						arrows: false,
					}
				}
			]
		}
		let {bans,homeData,country,countryActive}=this.state

		return (
			<div className='homeindex'>
				<Header isIndex={true}/>
				<div className='homecont container'>
					<div className='indexmain'>
						<div className='itop '>
							<div className='itopright'>
								<div className='ibanner'>
									<div>
										<Slider {...bannerSet}>
											{
												bans.map((item,index)=>(
													<div className={item.url?'bannerPoint':''} onClick={()=>{
														if (item.url){
															window.open(item.url)
														}
													}} key={index}><img src={item.image} className='img-fluid' alt='banner'/></div>
												))
											}
										</Slider>
									</div>

								</div>
								<div className='abbox'>
									<div className='abtitle'>专属定制留学申请方案</div>
									<div className='ablists'>
										<input type='text' placeholder='姓名'/>
									</div>
									<div className='ablists'>
										<input type='text' placeholder='联系方式'/>
									</div>
									<div className='ablists'>
										<select>
											<option>想去的国家</option>
											<option>美国</option>
											<option>英国</option>
										</select>
									</div>
									<div className='ablists'>
										<input type='text' placeholder='语言成绩'/>
									</div>
									<div className='ablists'>
										<input type='text' placeholder='目前学校'/>
									</div>
									<div onClick={this.selectElement} className='isubmitbtn'>免费获取</div>
								</div>
							</div>
						</div>
					</div>
					{
						//成功案例
					}
					<div className='indexbox'>
						<div className='secondtitle flex-between'>
							<div className='stitlefont flex-start module'>
								<div>留学资讯</div>
								<div className={'modulelist'}>
									<div className={'zxl'}>
										<div className={'zxlwrap'}>
											{
												country.map((item,index)=>(
													<div onClick={()=>{this.countryChange(item)}} className={countryActive.id===item.id?'zxactive':'zxlabel'} key={index}>{item.name}</div>
												))
											}
										</div>
									</div>
								</div>
							</div>
							<div className='clickall'>
								<a href='/information'>了解更多</a>
							</div>
						</div>
						<div className='zxcont flex-between'>
							<div className='zxleft'>
								<img src={countryActive.image} className="img-fluid" alt='peo'/>
							</div>
							<div className='zxright ' >
								<div className='zxrightcont'>
									{
										this.state.news.map((item, index) => (
											<div className='zxlistle' key={index} onClick={()=>{this.props.history.push('/informationdetail/'+item.id)}}>
												<div className={'zxlistleTitle'}>{item.title}</div> <span className={'zxlistle_time'}>{item.created_at}</span>
											</div>
										))
									}
								</div>
							</div>
						</div>
					</div>
					<div className='indexbox'>
						<div className='secondtitle flex-between'>
							<div className='stitlefont'>留学活动</div>
							<div className='clickall'>
								<a href='/activity'>了解更多</a>
							</div>
						</div>
						<Row>
							{
								homeData.event && homeData.event.data.length ? (
									homeData.event.data.map((item,index)=>(
										<Col md={4} key={index}>
											<div className='hdboxs' onClick={()=>{
												window.location.href='/activitydetail/'+item.id
											}}>
												<div><img src={item.image} className='img-fluid' alt='imgs'/></div>
												<div className='hdinfo'>
													<div className='hdbiaoti'>{item.title}</div>
													<div className='hdinc flex-start'>
														<div><img src={timeicon} className='img-fluid' alt='imgs'/></div>
														<div className='hdincfont'>{item.date}</div>
													</div>
													<div className='hdinc flex-start'>
														<div><img src={localicon} className='img-fluid' alt='imgs'/></div>
														<div className='hdincfont'>{item.location}</div>
													</div>
												</div>
											</div>
										</Col>
									))
								):null
							}
						</Row>
					</div>
					{
						//美国留学
					}
					<div className='indexbox mglxcont' onClick={()=>{
						window.open('/usa')
					}}>
						<div className='secondtitle flex-between'>
							<div className='stitlefont'>美国留学</div>
						</div>
						<Row>
							<Col md={4}>
								<div className='hdboxs'>
									<div><img src={mglx1} className='img-fluid banimg' alt='imgs'/>
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={mglx2} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit'>
										背景提升
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={mglx3} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit usnews'>
										2023 U.S.News<br/>
										美国大学排名
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<div><img src={mglx4} className='img-fluid banimg' alt='imgs'/>
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={mglx5} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit lxgh'>
										留学规划
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={mglx6} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit lqal'>
										录取学生案例
									</div>
								</div>
							</Col>
						</Row>
					</div>

					{
						//英联邦留学
					}
					<div className='indexbox ylblxcont' onClick={()=>{
						window.open('/uk')
					}}>
						<div className='secondtitle flex-between'>
							<div className='stitlefont'>英国留学</div>

						</div>
						<Row>
							<Col md={4}>
								<div className='hdboxs'>
									<div><img src={ylblx1} className='img-fluid banimg' alt='imgs'/>
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={ylblx2} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit'>
										2023本科留学申请
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={ylblx3} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit'>
										2023研究生留学申请
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={ylblx4} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit'>
										2023英国大学排名
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={ylblx5} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit'>
										外籍专家面试辅导
									</div>
								</div>
							</Col>
							<Col md={4}>
								<div className='hdboxs'>
									<img src={ylblx6} className='img-fluid banimg' alt='imgs'/>
									<div className='mglxtit'>
										剑桥大学PBL研学
									</div>
								</div>
							</Col>
						</Row>
					</div>

					{
						//师资团队
					}
					<div className='indexbox'>
						<div className='secondtitle flex-between'>
							<div className='stitlefont flex-start'>
								<div>师资团队</div>
								<div className='szlable'>超10年申请经验的中外籍专家</div>
							</div>
							<div className='clickall'>
								<a href='/teachers'>了解更多</a>
							</div>
						</div>
						<div className='sliderTeacher'>
							<Slider {...sets}>
								{
									this.state.teacherList.map((item, index) => (
										<div className="sliderdiv" key={index}>
											<div className='slidertu'>
												<img src={item.avatar} className="img-fluid" alt='peo'/>
												<div className='tnames'>{item.title} {item.name}</div>
											</div>
											<div className='yuyuebtn' onClick={this.selectElement}>预约老师</div>
										</div>
									))
								}
							</Slider>
						</div>
					</div>
					<div className='indexbox'>
						<div className='secondtitle flex-between'>
							<div className='stitlefont'>成功案例</div>
							<div className='clickall'>
								<a href='/case'>了解更多</a>
							</div>
						</div>
						<Row>
							{
								this.state.successCase.map((item, index) => (
									<Col md={4} className='cgboxs' key={index}>
										<div className='cgcase flex-start'>
											<div><img src={item.offer_image} className='img-fluid' alt='imgs'/></div>
											<div className='cgbri'>
												<div className='cgdam'>{item.school}</div>
												<div className='cgdier'>{item.student_name}</div>
												<div className='cgdierss'>{item.achievement}</div>
											</div>
										</div>
									</Col>
								))
							}


						</Row>
					</div>
					{
						//留学办理流程
					}
					<div className='indexbox lxliucheng'>
						<div className='secondtitle flex-between'>
							<div className='stitlefont'>
								<div>留学办理流程</div>
							</div>
							<div className='clickall'>
								<a href='/process'>了解更多</a>
							</div>
						</div>
						<div className='liuclist flex-between'>
							<div className='liucitem'>
								<div className='liuciteimg'><img src={lcbl1} className="img-fluid" alt='peo'/></div>
								<div>留学申请</div>
							</div>
							<div>
								<img src={lcbl9} className="img-fluid" alt='peo'/>
							</div>
							<div className='liucitem'>
								<div className='liuciteimg'><img src={lcbl2} className="img-fluid" alt='peo'/></div>
								<div>选校规划</div>
							</div>
							<div>
								<img src={lcbl9} className="img-fluid" alt='peo'/>
							</div>
							{/*<div className='liucitem'>*/}
							{/*	<div className='liuciteimg'><img src={lcbl3} className="img-fluid" alt='peo'/></div>*/}
							{/*	<div>活动规则</div>*/}
							{/*</div>*/}
							{/*<div>*/}
							{/*	<img src={lcbl9} className="img-fluid" alt='peo'/>*/}
							{/*</div>*/}
							<div className='liucitem'>
								<div className='liuciteimg'><img src={lcbl4} className="img-fluid" alt='peo'/></div>
								<div>院校申请</div>
							</div>
							<div>
								<img src={lcbl9} className="img-fluid" alt='peo'/>
							</div>
							<div className='liucitem'>
								<div className='liuciteimg'><img src={lcbl5} className="img-fluid" alt='peo'/></div>
								<div>文书创造</div>
							</div>
							<div>
								<img src={lcbl9} className="img-fluid" alt='peo'/>
							</div>
							<div className='liucitem'>
								<div className='liuciteimg'><img src={lcbl6} className="img-fluid" alt='peo'/></div>
								<div>面试指导</div>
							</div>
							<div>
								<img src={lcbl9} className="img-fluid" alt='peo'/>
							</div>
							<div className='liucitem'>
								<div className='liuciteimg'><img src={lcbl7} className="img-fluid" alt='peo'/></div>
								<div>签证办理</div>
							</div>
							<div>
								<img src={lcbl9} className="img-fluid" alt='peo'/>
							</div>
							<div className='liucitem'>
								<div className='liuciteimg'><img src={lcbl8} className="img-fluid" alt='peo'/></div>
								<div>后续服务</div>
							</div>
						</div>

						<div className="liuclistPhone">
							<div className='flex-between'>
								<div className='liucitem'>
									<div className='liuciteimg'><img src={lcbl4} className="img-fluid" alt='peo'/></div>
									<div>留学申请</div>
								</div>
								<div className='liucitem'>
									<div className='liuciteimg'><img src={lcbl1} className="img-fluid" alt='peo'/></div>
									<div>选校规划</div>
								</div>
								<div className='liucitem'>
									<div className='liuciteimg'><img src={lcbl2} className="img-fluid" alt='peo'/></div>
									<div>院校申请</div>
								</div>
								<div className='liucitem'>
									<div className='liuciteimg'><img src={lcbl5} className="img-fluid" alt='peo'/></div>
									<div>文书创造</div>
								</div>
								{/*<div className='liucitem'>*/}
								{/*	<div className='liuciteimg'><img src={lcbl3} className="img-fluid" alt='peo'/></div>*/}
								{/*	<div>活动规则</div>*/}
								{/*</div>*/}

							</div>
							<div className='flex-between'>
								<div className='liucitem'>
									<div className='liuciteimg'><img src={lcbl6} className="img-fluid" alt='peo'/></div>
									<div>面试指导</div>
								</div>

								<div className='liucitem'>
									<div className='liuciteimg'><img src={lcbl7} className="img-fluid" alt='peo'/></div>
									<div>签证办理</div>
								</div>

								<div className='liucitem'>
									<div className='liuciteimg'><img src={lcbl8} className="img-fluid" alt='peo'/></div>
									<div>后续服务</div>
								</div>
								<div className='liucitem'>
									{/*<div className='liuciteimg'><img src={lcbl8} className="img-fluid" alt='peo'/></div>*/}
									{/*<div>后续服务</div>*/}
								</div>
							</div>
						</div>
					</div>

				</div>
				<Footer/>
			</div>
		)
	}
}

export default Home
